import { IconProps } from "../../utils/global-types/global-types";

const CreatedDateIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.125 5.25a3.125 3.125 0 1 1-6.25 0 3.125 3.125 0 0 1 6.25 0M7.75 9.625A4.375 4.375 0 0 0 3.375 14c0 1.036.84 1.875 1.875 1.875h4.63c.27 0 .424-.33.284-.561a3.73 3.73 0 0 1-.539-1.939c0-1.271.633-2.395 1.6-3.073.227-.16.208-.524-.063-.582a4.4 4.4 0 0 0-.912-.095zm5.625 1.25c.345 0 .625.28.625.625v1.25h1.25a.625.625 0 1 1 0 1.25H14v1.25a.625.625 0 0 1-1.25 0V14H11.5a.625.625 0 1 1 0-1.25h1.25V11.5c0-.345.28-.625.625-.625"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default CreatedDateIcon;
